import { AxiosInstance, AxiosResponse } from 'axios';
import {
	ListWithTotals,
	PastEventFileDto,
	PastEventFilesFilterDto,
	UsersToPastEventsFilter,
	PastEventsWithGroupedDraftsDto,
	PastEventsFilter,
	PastEventDto,
	CreatePastEventFromAdminPanelDto,
	UserToPastEventDto,
	FeedActivitiesFilter,
	AddCommonActivity,
	UpdateCommonActivity,
} from '@sweatpals/shared';

export class PastEventsService {
	private readonly baseRoute = 'past-events';

	private readonly feedRoute = 'stream-feed';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getEvents(filter: UsersToPastEventsFilter): Promise<AxiosResponse<PastEventsWithGroupedDraftsDto>> {
		return this.httpClient.post<PastEventsWithGroupedDraftsDto>(`${this.baseRoute}/journal/search`, filter);
	}

	public async getPastEvents(filter: PastEventsFilter): Promise<AxiosResponse<ListWithTotals<PastEventDto>>> {
		return this.httpClient.get<ListWithTotals<PastEventDto>>(`${this.baseRoute}/`, { params: filter });
	}

	public async getPastEventFiles(
		pastEventId: string,
		filter: PastEventFilesFilterDto
	): Promise<AxiosResponse<ListWithTotals<PastEventFileDto>>> {
		return this.httpClient.get<ListWithTotals<PastEventFileDto>>(`${this.baseRoute}/${pastEventId}/files`, {
			params: filter,
		});
	}

	public async deletePastEventFromJournal(userToPastEventId: string): Promise<AxiosResponse<void>> {
		return this.httpClient.delete<void>(`${this.baseRoute}/user-to-past-event/${userToPastEventId}`);
	}

	public async createJournalAsAdmin(
		body: CreatePastEventFromAdminPanelDto
	): Promise<AxiosResponse<UserToPastEventDto>> {
		return this.httpClient.post<UserToPastEventDto>(`${this.baseRoute}/admin/create-journal`, body);
	}

	public async updateJournalAsAdmin(
		userToPastEventId: string,
		body: CreatePastEventFromAdminPanelDto
	): Promise<AxiosResponse<UserToPastEventDto>> {
		return this.httpClient.put<UserToPastEventDto>(`${this.baseRoute}/admin/update-journal/${userToPastEventId}`, body);
	}

	public async getPastEventsForDashboard(
		filter: PastEventsFilter
	): Promise<AxiosResponse<ListWithTotals<PastEventDto>>> {
		return this.httpClient.get<ListWithTotals<PastEventDto>>(`${this.baseRoute}/dashboard`, { params: filter });
	}

	public async getFeedJournalsForAdmin(filter: FeedActivitiesFilter): Promise<AxiosResponse> {
		return this.httpClient.get<unknown>(`${this.feedRoute}/admin/activities`, { params: filter });
	}

	public async createFeedActivityForAdmin(body: AddCommonActivity): Promise<AxiosResponse> {
		return this.httpClient.post<unknown>(`${this.feedRoute}/activity`, body);
	}

	public async updateFeedActivityForAdmin(body: UpdateCommonActivity): Promise<AxiosResponse> {
		return this.httpClient.put<unknown>(`${this.feedRoute}/update/activity`, body);
	}

	public async deleteFeedActivityForAdmin(feedId: string, activityId: string): Promise<AxiosResponse> {
		return this.httpClient.delete<unknown>(`${this.feedRoute}/delete/feed/${feedId}/activity/${activityId}`);
	}
}

export default PastEventsService;
